import { API, Auth } from "aws-amplify";
import { IAirportOption } from "src/redux/reducers/StructuresReducer";

export class AirportRequestMultiplexer {
  private static pendingDispatchs = new Set<string>();

  public static async dispatchAirportGetAirport(
    ident: string,
    dispatcher: (airports: IAirportOption[]) => void
  ): Promise<void> {
    if (this.pendingDispatchs.has(ident)) return;
    else {
      this.pendingDispatchs.add(ident);
      const userSession = await Auth.currentSession();
      const token = userSession.getIdToken().getJwtToken();
      const airports = await API.get("skytrains", `/searchAirports?searchStr=${ident}`, {
        headers: { Accept: "*/*", Authorization: token },
      });
      this.pendingDispatchs.delete(ident);
      if (airports) {
        const airportOptions = airports.map((airport: any) => {
          return {
            _id: airport._id,
            ident: airport.Ident,
            name: airport.Name,
            timezoneId: airport.timezoneId,
            iata: airport.IATACode,
            gates: airport.gates,
          };
        });
        dispatcher(airportOptions);
      }
    }
  }
}
